<template>
  <div class="btn-bottom-margin">
    <h1 class="header-style">
      Timesheets
    </h1>
    <div>
      <v-tabs
        v-model="tab"
        class="tab-style mt-5"
        rounded
        color="transparent"
        active-class="selected-tab"
        light
      >
        <v-tab class="tab-all">
          <v-icon size="15">
            mdi-history
          </v-icon> All
        </v-tab>
        <v-tab class="tab-pending">
          <v-icon size="15">
            mdi-clock-outline
          </v-icon> Pending
        </v-tab>
        <v-tab class="tab-approved">
          <v-icon size="15">
            mdi-check-circle-outline
          </v-icon> Approved
        </v-tab>
      </v-tabs>
      <v-tabs-items
        v-model="tab"
        class="my-tabs-background-style"
        touchless
      >
        <v-tab-item>
          <v-card-text>
            <time-sheets-all />
          </v-card-text>
        </v-tab-item>
        <v-tab-item>
          <v-card-text>
            <time-sheets-pending />
          </v-card-text>
        </v-tab-item>
        <v-tab-item>
          <v-card-text>
            <time-sheets-approved />
          </v-card-text>
        </v-tab-item>
      </v-tabs-items>
      <br>
      <br>
    </div>
    <centre-spinner :loading="loading" />
  </div>
</template>
<script>
import spinner from 'src/views/components/SpinnerCentre';
import TimeSheetApproved from './dialogComponents/TimesheetsDialogs/TimeSheetApproved.vue';
import TimeSheetPending from './dialogComponents/TimesheetsDialogs/TimeSheetPending.vue';
import TimeSheetAll from './dialogComponents/TimesheetsDialogs/TimesheetAll.vue';
export default {
  name: 'TimesheetsPage',
  components: {
    'centre-spinner': spinner,
    'time-sheets-approved': TimeSheetApproved,
    'time-sheets-pending': TimeSheetPending,
    'time-sheets-all': TimeSheetAll,
  },
  data: () => ({
    loading: false,
    tab: null,
  }),
  computed: {
    selectedOrganization () {
      return this.$store.getters.getSelectedOrganization;
    },
  },
  async mounted () {
    await this.$store
        .dispatch(
          'organization/fetchOrganizationSettings',
          this.selectedOrganization,
        );
  },
};
</script>

<style scoped>
.from-style {
  position: relative;
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
}

.my-tabs-background-style {
  background-color: transparent;
}

.v-item-group
  theme--dark
  v-slide-group
  v-tabs-bar
  v-tabs-bar--is-mobile
  primary--text {
  width: 100%;
}

.v-slide-group__content v-tabs-bar__content {
  width: 100%;
  display: flex;
  justify-content: space-around;
}

.v-tabs-slider-wrapper {
  background-color: transparent !important;
}

.v-slide-group__content v-tabs-bar__content {
  background: #000;
}

.v-tab {
  color: #000000 !important;
  border-radius: 10px;
  height: 30px;
  margin-top: 10px;
  margin-right: 10px;
  display: flex;
  gap: 10px;
  background: #fff;
}

.v-tab.tab-pending {
  width: 40% !important;
  border: 1px solid #ffca68;
}

.v-tab--active.tab-pending {
  color: #ffffff !important;
  background: #ffca68;
  border: none;
}

.v-tab.tab-approved {
  width: 40% !important;
  border: 1px solid #63ca7f;
}

.v-tab--active.tab-approved {
  color: #ffffff !important;
  background: #63ca7f;
  border: none;
}
.v-tab.tab-all {
  width: 40% !important;
  border: 1px solid #00000062;
}

.v-tab--active.tab-all {
  color: #ffffff !important;
  background: #000000;
  border: none;
}

.selected-tab {
  color: #fff;
}

.v-tab {
  font-size: 10px !important;
}

.v-card__text {
  padding: 0px !important;
}
:deep(.v-slide-group__prev),
:deep(.v-slide-group__next) {
  display: none !important;
}
.timesheet-btn-style {
  font-weight: 700;
  text-transform: none;
  border-radius: 10px;
}
</style>
